const retrieveCryptoFromDesc = ({description}) => {
    return description.slice(description.indexOf('[B]') + 3, description.indexOf('[/B]'))
}

export const NotificationHelper = {
    retrieveCryptoFromDesc,
    supportedTypes: [0, 38, 82, 84, 32],
    notificationContentType: {
        general: 0,
        trading: 38,
        credit_card: 32,
        campaign_register: 82,
        campaign_action: 84
    }
}